import { render } from "./AppInput.vue?vue&type=template&id=5285024d&scoped=true"
import script from "./AppInput.vue?vue&type=script&lang=js"
export * from "./AppInput.vue?vue&type=script&lang=js"

import "./AppInput.vue?vue&type=style&index=0&id=5285024d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5285024d"]])

export default __exports__